import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { parseCompany } from '../helpers';

import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { companySearch } from '../actions';
import { selectAddressTypes } from '../../Address/selectors';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANIES_SEARCH } from '../constants';
import { Loader } from '../../../components/Loader';
import { Button } from '../../../components/Buttons';
import { Search } from '../../../components/Icon';

import ButtonComponent from '../../../containers/App/Components/Button/Button';
import NotificationComponent from '../../../containers/App/Components/Notification/Notification';
import styles from './CompanySelection.module.css';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import { CompanySelectionResultTable } from './CompanySelectionResultTable';

const STATE = {
  string: '',
  showNotification: false,
};

const Container = styled.div`
  width: 100%;
  .results {
    max-height: 60vh;
    overflow-y: auto;
    width: 100%;
  }

  .form-controlField,
  .form-controlField > div {
    width: 100%;
  }
`;

const DropdownOptions = styled.ul`
  display: block;
  position: absolute;
  z-index: 10;
  box-sizing: border-box;
  border-radius: 0.375rem;
  top: 40px;
  left: 0;
  width: 100%;
  list-style: none;
  border: solid 1px #eee;
  padding: ${({ show }) => (show ? '0' : '0')};
  background-color: white;
  max-height: 350px;
  overflow: auto;
`;

const DropdownOption = styled.li`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  background-color: ${({ isSelected }) => (isSelected ? '#86b6fe3b' : 'white')};
  color: ${({ isSelected }) => (isSelected ? 'black' : 'inherited')};

  &:hover {
    background-color: #86b6fe3b;
    color: black;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class CompanySelectionComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  getHomeAddressCity(company) {
    const addressTypeId = this.props.addressTypes.filter(t => t.name === 'home')[0]?.id;
    const city = company?.addresses?.filter(a => a?.typeId == addressTypeId)[0]?.city;
    return city ? ', ' + city : '';
  }

  onStringChange(evt) {
    let string = evt.target.value;
    this.setState({ string });
    this._t = !this.props.order && !this.props.changeLocation && this.timeout(this.search.bind(this), 300, this._t);
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.search();
    }
  };

  search() {
    const search = normalizeSearchString(this.state.string)?.trim();

    this.props.search(search, result => {
      if (!result || !result.items) {
        return this.setState({ result: [] });
      }

      const filteredResults = result.items
        .map(parseCompany)
        .filter(c => {
          if ((env.clientId === AppClientId.INDEWAL || env.clientId === AppClientId.IDWLEASE) && this.props.order) {
            return c.status !== '5' && c.status !== '2';
          }
          return c.status !== '5';
        })
        .filter(company => {
          if (this.props.customerNumberSearch) {
            return company.id !== this.props.company?.id;
          }
          return (
            company.id !== this.props.company?.id &&
            (company.__search.includes(search) || company.__email_search.includes(search))
          );
        });

      this.setState({ result: filteredResults });
    });
  }

  handleShowNotification = () => {
    this.setState({ showNotification: true });
  };

  render() {
    let searchingProcess = this.props.searching;

    if (this.props.order || this.props.changeLocation) {
      searchingProcess = this.props.searching === 3;
    }

    return (
      <div className={styles.container}>
        <div className={styles.flexContainer}>
          <input
            className="form-control"
            name="string"
            onChange={this.onStringChange.bind(this)}
            onKeyPress={(this.props.order || this.props.changeLocation) && this.handleKeyPress}
            value={this.state.string}
            placeholder={this.lblStr('company.search.placeholder')}
          />
          {this.state.result?.length === 0 ? (
            <NotificationComponent
              show={this.handleShowNotification()}
              onClose={() => this.setState({ showNotification: false })}
              text={this.lbl('company.search.not_found')}
              variant={'warning'}
            />
          ) : (
            this.renderResult()
          )}
          {this.props.order || this.props.changeLocation ? (
            <div className={styles.button}>
              <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.search.bind(this)}>
                {searchingProcess ? <Loader small /> : <Search />}
              </ButtonComponent>
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  renderResult() {
    if (!this.state.result) return '';

    return (
      <DropdownOptions>
        <CompanySelectionResultTable
          companies={this.state.result}
          onCompanySelect={company => {
            this.setState({ result: null });
            if (this.props.onSelect) this.props.onSelect(company);
          }}
        />
      </DropdownOptions>
    );
  }
}

CompanySelectionComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    addressTypes: selectAddressTypes(),
    searching: selectWork(REQUEST_COMPANIES_SEARCH),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    search(string, callback) {
      dispatch(companySearch(string, callback));
      //search ...
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanySelection = compose(withConnect, withRouter, injectIntl)(CompanySelectionComp);
